import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, TransitionGroup as _TransitionGroup, toDisplayString as _toDisplayString, KeepAlive as _KeepAlive, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/Logo.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-6559f759")

_pushScopeId("data-v-6559f759")
const _hoisted_1 = /*#__PURE__*/_createVNode("p", null, "Soll die ausgewählte Wissensbasis aus der Liste gelöscht werden?", -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Um den geteilten Zustand vollständig rekonstruieren zu können, müssen neue Endpunkte importiert werden. "),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" Wollen Sie die erforderlichen Endpunkte jetzt automatisch hinzufügen lassen?")
], -1)
const _hoisted_3 = { class: "main" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "logobox" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    alt: "OntoExplorer",
    class: "logo"
  })
], -1)
const _hoisted_5 = { class: "mainmenubox" }
const _hoisted_6 = /*#__PURE__*/_createVNode("a", { href: "https://gitlab.imn.htwk-leipzig.de/ontoexplorer/ontoexplorer" }, [
  /*#__PURE__*/_createVNode("button", { id: "infoBtn" }, [
    /*#__PURE__*/_createVNode("span", {
      class: "material-icons",
      style: {"font-size":"26px"}
    }, "public")
  ])
], -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("span", {
  class: "material-icons",
  style: {"font-size":"26px"}
}, "help_outline", -1)
const _hoisted_8 = { class: "menubox" }
const _hoisted_9 = { class: "menu-header" }
const _hoisted_10 = /*#__PURE__*/_createVNode("h5", { id: "base" }, "Wissensbasis", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "material-icons" }, "more_vert", -1)
const _hoisted_12 = {
  key: 0,
  id: "dropdown"
}
const _hoisted_13 = /*#__PURE__*/_createVNode("span", { class: "material-icons" }, "add", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("p", null, "Hinzufügen", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("span", { class: "material-icons" }, "share", -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("p", null, "Exportieren", -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("span", { class: "material-icons" }, "file_upload", -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("p", null, "Importieren", -1)
const _hoisted_19 = { class: "menucontent" }
const _hoisted_20 = { class: "menubox-large" }
const _hoisted_21 = /*#__PURE__*/_createVNode("h5", null, "Klassenhierarchie", -1)
const _hoisted_22 = { class: "menucontent" }
const _hoisted_23 = { class: "menubox" }
const _hoisted_24 = /*#__PURE__*/_createVNode("h5", null, "Attribute", -1)
const _hoisted_25 = { class: "menucontent" }
const _hoisted_26 = { class: "resultsbox" }
const _hoisted_27 = { class: "results-header" }
const _hoisted_28 = /*#__PURE__*/_createVNode("span", { class: "material-icons" }, "chevron_left", -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("span", { class: "material-icons" }, "share", -1)
const _hoisted_30 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "OntoExplorer",
  class: "small-logo"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_AddEndpointDialog = _resolveComponent("AddEndpointDialog")
  const _component_GenericDialog = _resolveComponent("GenericDialog")
  const _component_EditEndpointDialog = _resolveComponent("EditEndpointDialog")
  const _component_ShareStateDialog = _resolveComponent("ShareStateDialog")
  const _component_HelpDialog = _resolveComponent("HelpDialog")
  const _component_ExportEndpointsDialog = _resolveComponent("ExportEndpointsDialog")
  const _component_ImportEndpointsDialog = _resolveComponent("ImportEndpointsDialog")
  const _component_Tooltip = _resolveComponent("Tooltip")
  const _component_ListOfEndpoints = _resolveComponent("ListOfEndpoints")
  const _component_ListOfClasses = _resolveComponent("ListOfClasses")
  const _component_ListOfProperties = _resolveComponent("ListOfProperties")
  const _component_ListOfInstances = _resolveComponent("ListOfInstances")
  const _component_InstanceInfoTable = _resolveComponent("InstanceInfoTable")

  return (_openBlock(), _createBlock("body", null, [
    _createVNode(_TransitionGroup, { name: "dialog" }, {
      default: _withId(() => [
        (_ctx.AddEndpointDialogshown)
          ? (_openBlock(), _createBlock(_component_AddEndpointDialog, {
              key: 0,
              onCanceled: _ctx.hideAddEndpointDialog,
              onSubmitted: _ctx.testDialogData,
              header_text: "Neue Wissensbasis hinzufügen",
              body_text: "Um eine neue Wissensbasis einzubinden, müssen Sie die entsprechende URL angeben:",
              footer_text: "*müssen ausgefüllt sein"
            }, null, 8, ["onCanceled", "onSubmitted"]))
          : _createCommentVNode("", true),
        (_ctx.removingEndpoint != null)
          ? (_openBlock(), _createBlock(_component_GenericDialog, {
              key: 1,
              buttons: ['Entfernen', 'Abbrechen'],
              onClicked: _cache[1] || (_cache[1] = btn => {switch (btn) {case 0: _ctx.RemoveEndpoint(); case 1: _ctx.hideRemoveEndpointDialog();}}),
              onClose: _ctx.hideRemoveEndpointDialog,
              header_text: "Wissensbasis entfernen",
              max_width: "300px"
            }, {
              default: _withId(() => [
                _hoisted_1
              ]),
              _: 1
            }, 8, ["onClose"]))
          : _createCommentVNode("", true),
        (_ctx.editingEndpoint != null)
          ? (_openBlock(), _createBlock(_component_EditEndpointDialog, {
              key: 2,
              onCanceled: _ctx.hideEditEndpointDialog,
              onSubmitted: _ctx.hideEditEndpointDialog,
              header_text: "Wissensbasis editieren",
              body_text: "Sie können Namen und URL der ausgewählten Wissensbasis ändern:",
              footer_text: "*müssen ausgefüllt sein",
              currentEndpoint: _ctx.editingEndpoint
            }, null, 8, ["onCanceled", "onSubmitted", "currentEndpoint"]))
          : _createCommentVNode("", true),
        (_ctx.isSharingUrl === true)
          ? (_openBlock(), _createBlock(_component_ShareStateDialog, {
              key: 3,
              onClose: _ctx.hideShareStateDialog,
              "share-url": _ctx.shareUrl,
              "state-json": _ctx.shareJsonData
            }, null, 8, ["onClose", "share-url", "state-json"]))
          : _createCommentVNode("", true),
        (_ctx.addMissingEndpointsDialogShown)
          ? (_openBlock(), _createBlock(_component_GenericDialog, {
              key: 4,
              buttons: ['Hinzufügen', 'Abbrechen'],
              onClicked: _cache[2] || (_cache[2] = btn => {switch (btn) {case 0: _ctx.addMissingEndpoints(); case 1: _ctx.hideAddMissingEndpointsDialog();}}),
              onClose: _ctx.hideAddMissingEndpointsDialog,
              header_text: "Wissensbasen hinzufügen",
              max_width: "25em",
              buttons_style: "justify-content: center;"
            }, {
              default: _withId(() => [
                _hoisted_2
              ]),
              _: 1
            }, 8, ["onClose"]))
          : _createCommentVNode("", true),
        (_ctx.HelpShown)
          ? (_openBlock(), _createBlock(_component_HelpDialog, {
              key: 5,
              onCancel: _ctx.hideHelp
            }, null, 8, ["onCancel"]))
          : _createCommentVNode("", true),
        (_ctx.exportEndpointsDialogShown)
          ? (_openBlock(), _createBlock(_component_ExportEndpointsDialog, {
              key: 6,
              onClose: _ctx.hideExportEndpointsDialog
            }, null, 8, ["onClose"]))
          : _createCommentVNode("", true),
        (_ctx.importEndpointsDialogShown)
          ? (_openBlock(), _createBlock(_component_ImportEndpointsDialog, {
              key: 7,
              onClose: _ctx.hideImportEndpointsDialog
            }, null, 8, ["onClose"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode("div", _hoisted_3, [
      _createVNode("header", null, [
        _hoisted_4,
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_Tooltip, { text: `Projekt-Webseite` }, {
            default: _withId(() => [
              _hoisted_6
            ]),
            _: 1
          }),
          _createVNode(_component_Tooltip, { text: `Hilfestellung` }, {
            default: _withId(() => [
              _createVNode("button", {
                id: "helpBtn",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showHelp()))
              }, [
                _hoisted_7
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode("div", _hoisted_8, [
        _createVNode("div", _hoisted_9, [
          _hoisted_10,
          _createVNode("button", {
            id: "dropdownBtn",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toggleDropdown()))
          }, [
            _hoisted_11
          ]),
          (_ctx.showDropdown)
            ? (_openBlock(), _createBlock("div", _hoisted_12, [
                _createVNode("div", {
                  class: "dropdown-item",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showAddEndpointDialog(),_ctx.toggleDropdown()))
                }, [
                  _hoisted_13,
                  _hoisted_14
                ]),
                _createVNode("div", {
                  class: "dropdown-item",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showExportEndpointsDialog(),_ctx.toggleDropdown()))
                }, [
                  _hoisted_15,
                  _hoisted_16
                ]),
                _createVNode("div", {
                  class: "dropdown-item",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showImportEndpointsDialog(),_ctx.toggleDropdown()))
                }, [
                  _hoisted_17,
                  _hoisted_18
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_19, [
          _createVNode(_component_ListOfEndpoints, {
            onRemove: _ctx.showRemoveEndpointDialog,
            onEdit: _ctx.showEditEndpointDialog,
            onEnabledEndpointsChanged: _ctx.updateURL
          }, null, 8, ["onRemove", "onEdit", "onEnabledEndpointsChanged"])
        ])
      ]),
      _createVNode("div", _hoisted_20, [
        _hoisted_21,
        _createVNode("div", _hoisted_22, [
          _createVNode(_component_ListOfClasses)
        ])
      ]),
      _createVNode("div", _hoisted_23, [
        _hoisted_24,
        _createVNode("div", _hoisted_25, [
          _createVNode(_component_ListOfProperties, {
            onFinishLoad: _cache[8] || (_cache[8] = ($event: any) => (_ctx.continueRestoreState()))
          })
        ])
      ]),
      _createVNode("div", _hoisted_26, [
        _createVNode("div", _hoisted_27, [
          _createVNode("button", {
            id: "returnBtn",
            disabled: (_ctx.selectedInstance === null),
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.BackButtonClick()))
          }, [
            _hoisted_28
          ], 8, ["disabled"]),
          _createVNode("h5", null, _toDisplayString(_ctx.resultbox_caption), 1),
          _createVNode("button", {
            id: "shareBtn",
            disabled: (_ctx.ListOfInstancesshown || _ctx.InstanceInfoTableshown) === false,
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.shareStateUrl()))
          }, [
            _hoisted_29
          ], 8, ["disabled"])
        ]),
        (_openBlock(), _createBlock(_KeepAlive, null, [
          (!_ctx.selectedInstance)
            ? (_openBlock(), _createBlock(_component_ListOfInstances, {
                key: 0,
                onShowInstance: _ctx.showInstanceInfoTable
              }, null, 8, ["onShowInstance"]))
            : _createCommentVNode("", true)
        ], 1024)),
        (_ctx.selectedInstance)
          ? (_openBlock(), _createBlock(_component_InstanceInfoTable, {
              key: 0,
              instance: _ctx.selectedInstance,
              onShowInstance: _ctx.showInstanceInfoTable
            }, null, 8, ["instance", "onShowInstance"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("footer", null, [
        _createVNode(_component_Tooltip, { text: _ctx.versionLong }, {
          default: _withId(() => [
            _createVNode("span", null, "Version " + _toDisplayString(_ctx.versionShort), 1)
          ]),
          _: 1
        }, 8, ["text"]),
        _hoisted_30
      ])
    ])
  ]))
})